import { createSlice } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';
import { AuthType } from './models';

const parseToken = (token: Record<string, string>) => {
  return { email: token.email, isAdmin: token.isAdmin === 'true' };
};

export const initialState: AuthType = {
  idToken: '',
  tokenType: '',
  decodedToken: { email: '', isAdmin: false },
};

// Redux Slice
export const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action) => {
      const { idToken, tokenType } = action.payload as AuthType;

      state.idToken = idToken;
      state.tokenType = tokenType;

      if (tokenType === 'AWS' && idToken) {
        state.decodedToken = parseToken(jwtDecode(idToken));
      }
    },
    setMockToken: (state, action) => {
      const { idToken, tokenType, decodedToken } = action.payload as AuthType;

      state.idToken = idToken;
      state.tokenType = tokenType;
      state.decodedToken = decodedToken;
    },
  },
});

// redux selectors
export const selectAuth = (state: { auth: AuthType }) => state.auth;

// auto-generated redux actions
export const { setToken, setMockToken } = slice.actions;
